/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react'
import { IBoletoDepositoResponse } from 'modules/pagamentos/domain/entities/IBoletoDepositoResponse'
import {
  Text,
  Label,
  Column,
  Status,
  Row,
  Container,
  Title,
  ContainerInfo,
  Info,
} from './styles'
import Drawer from 'shared/components/Drawer'
import { numberToCurrency } from 'shared/utils/formatters'
import { MdInfoOutline } from 'react-icons/md'
import { colors } from 'shared/styles/colors'
import { IBaixarPdfBoletoDeposito } from 'modules/pagamentos/domain/usecases/BaixarPdfBoletoDeposito'
import { useFrotista } from 'modules/user/hooks/useFrotista'
import SnackBar from 'shared/components/SnackBar'
import Button from 'shared/components/Button'

export type TProps = {
  boleto: IBoletoDepositoResponse
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  baixarPdfBoletoDeposito: IBaixarPdfBoletoDeposito
}

const DetalhesBoleto: React.FC<TProps> = ({
  boleto,
  open,
  setOpen,
  baixarPdfBoletoDeposito,
}) => {
  const { frotistaId } = useFrotista()
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [openErrorMessage, setOpenErrorMessage] = useState(false)

  const handleBaixarPdfBoletoDeposito = async () => {
    setLoading(true)

    try {
      const response = await baixarPdfBoletoDeposito.execute({
        frotista_id: frotistaId,
        codigo_de_barras: boleto.codigo_de_barras,
        id_unico_dock: boleto.id_unico_dock,
      })
      const file = new Blob([response], { type: 'application/pdf' })
      const fileURL = URL.createObjectURL(file)
      window.open(fileURL)
    } catch (error: unknown) {
      if (error instanceof Error) {
        setErrorMessage(error.message || 'Erro ao atualizar os valores')
      } else {
        setErrorMessage('Erro ao atualizar os valores')
      }
      setOpenErrorMessage(true)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Drawer open={open} onCloseModal={() => setOpen(false)} width="400px">
        <Container>
          <Title>Detalhes do boleto</Title>
          <Row>
            <Status status={boleto.status} />
            <Text>{boleto.status}</Text>
          </Row>
          <Column>
            <Label>Favorecido</Label>
            <Text>{boleto.favorecido}</Text>
          </Column>
          <Row>
            <Column>
              <Label>Vencimento</Label>
              <Text>{boleto.data_de_vencimento}</Text>
            </Column>
            <Column>
              <Label>Valor</Label>
              <Text>{numberToCurrency(boleto.valor)}</Text>
            </Column>
          </Row>
          <Column>
            <Label>Emissão</Label>
            <Text>{boleto.data_emissao}</Text>
          </Column>
          <Column>
            <Label>Código de barras</Label>
            <Text>{boleto.codigo_de_barras}</Text>
          </Column>
          <ContainerInfo>
            <MdInfoOutline size={32} style={{ color: colors.yellow }} />
            <Info>
              Após o pagamento do boleto, o valor estará disponível em sua conta
              no prazo de até 3 dias úteis.
            </Info>
          </ContainerInfo>
          <Button
            style={{
              width: '100%',
              position: 'absolute',
              bottom: 25,
              left: 0,
              right: 0,
              margin: '0 auto',
            }}
            color={colors.green}
            loading={loading}
            onClick={handleBaixarPdfBoletoDeposito}
          >
            Baixar boleto
          </Button>
        </Container>
      </Drawer>
      <SnackBar
        open={openErrorMessage}
        setOpen={setOpenErrorMessage}
        severity="error"
        message={errorMessage}
        horizontal="right"
      />
    </>
  )
}

export default DetalhesBoleto
